// 店舗メニューの描画（試作 prototypes/home/menu.html の script を移植）。データは ss-menu-data.js、写真の URL はセクションが #menu-img に出す。

// 描画は DOM API と textContent のみ（innerHTML は使わない）
(function () {
  const IMG = JSON.parse(document.getElementById("menu-img").textContent || "{}");
  const el = (tag, props = {}, kids = []) => {
    const n = document.createElement(tag);
    for (const [k, v] of Object.entries(props)) {
      if (k === "text") n.textContent = v;
      else if (k === "class") n.className = v;
      else n.setAttribute(k, v);
    }
    for (const c of kids) if (c) n.append(c);
    return n;
  };
  const yen = (p) => "¥" + p.toLocaleString("ja-JP");
  const root = document.getElementById("menu-root");
  const cats = document.getElementById("cats");

  // 品名の折り返し位置（スマホ）: 決めた語の後ろだけで折る。CSS の keep-all と組み合わせる
  const JA_BREAK_AFTER = ["さんちの", "ホワイトチョコ", "フラワー"];
  const jaName = (name) => {
    const out = [];
    let rest = name;
    for (const w of JA_BREAK_AFTER) rest = rest.split(w).join(w + "\u0000");
    rest.split("\u0000").forEach((t, i, a) => { if (t) out.push(document.createTextNode(t)); if (i < a.length - 1 && a[i + 1]) out.push(document.createElement("wbr")); });
    return out;
  };
  for (const cat of window.MENU) {
    cats.append(el("a", { href: "#" + cat.id, "data-cat": cat.id }, [document.createTextNode(cat.en), el("small", { text: cat.ja })]));
    const list = el("ul", { class: "items" });
    for (const it of cat.items) {
      const img = el("img", { src: IMG[it.img || it.id] || "", alt: it.ja, loading: "lazy", width: "480", height: "480" });
      const title = el("h3", {}, [el("span", { class: "t-ja" }, jaName(it.ja)), el("span", { class: "t-en", text: it.en || it.ja })]);
      const sub = el("p", { class: "sub" }, [el("span", { class: "t-ja", text: it.en }), el("span", { class: "t-en", text: it.en ? it.ja : "" })]); // .t-ja＝JA 表示のとき見える側
      const tags = it.temp ? el("p", { class: "tags" }, it.temp.map((t) => el("span", { class: t.toLowerCase(), text: t }))) : null;
      const descs = [];
      if (it.dja) descs.push(el("p", { class: "desc", lang: "ja", text: it.dja }));
      if (it.den) descs.push(el("p", { class: "desc", lang: "en", text: it.den }));
      list.append(el("li", { class: "item" }, [
        el("div", { class: "ph" }, [img]),
        el("div", { class: "nm" }, [title, el("p", { class: "price", text: yen(it.price) })]),
        it.en || it.ja ? sub : null, tags, ...descs,
      ]));
    }
    root.append(el("section", { class: "cat", id: cat.id, "aria-labelledby": cat.id + "-h" }, [
      el("header", { class: "cat-hd" }, [el("h2", { id: cat.id + "-h", text: cat.en }), el("span", { text: cat.ja }), el("span", { class: "count", text: cat.items.length + " items" })]),
      list,
    ]));
  }

  // OUR MATCHA は MATCHA の章の頭に置く（抹茶の話なので）
  const our = document.querySelector(".our"), mt = document.getElementById("matcha");
  if (our && mt) mt.insertBefore(our, mt.querySelector(".items"));

  // スマホ：説明はタップで全文
  root.addEventListener("click", (e) => {
    const d = e.target.closest(".desc");
    if (d) d.classList.toggle("open");
  });

  // 言語の切り替え（表示だけ。選んだ言語はこの端末に覚える）
  const setLang = (lang) => {
    document.documentElement.dataset.lang = lang;
    document.documentElement.lang = lang;
    document.querySelectorAll(".lang button").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.lang === lang)));
    try { localStorage.setItem("ss-lang", lang); } catch (_) {}
  };
  document.querySelectorAll(".lang button").forEach((b) => b.addEventListener("click", () => setLang(b.dataset.lang)));
  let saved = null;
  try { saved = localStorage.getItem("ss-lang"); } catch (_) {}
  if (saved === "en" || saved === "ja") setLang(saved);

  // いま見ているカテゴリを帯に反映
  const links = [...cats.querySelectorAll("a")];
  if (links[0]) links[0].setAttribute("aria-current", "true"); // 開いた直後（背の低い画面だと監視の帯に章がまだ入らない）も 1 つ目を選択中に
  const io = new IntersectionObserver((ents) => {
    for (const en of ents) {
      if (!en.isIntersecting) continue;
      links.forEach((a) => a.setAttribute("aria-current", String(a.dataset.cat === en.target.id)));
      const a = links.find((x) => x.dataset.cat === en.target.id);
      if (a) cats.scrollTo({ left: a.offsetLeft - 12, behavior: "smooth" });
    }
  }, { rootMargin: "-40% 0px -55% 0px" });
  document.querySelectorAll(".cat").forEach((s) => io.observe(s));
})();
